import NumberHelper from "./NumberHelper";

const isPresent = value => value !== null && typeof value !== "undefined";

export const ZONE_PARAMETER_TYPES = {
  DEMAND: "DEMAND",
  SUPPLY: "SUPPLY"
};

export default class ZoneParametersHelper {
  static hasZoneParameters(resultMetaData) {
    if (!resultMetaData) {
      return false;
    }

    return (
      isPresent(resultMetaData.bottom) && isPresent(resultMetaData.top)
    );
  }

  static getZoneType(resultMetaData) {
    const type = resultMetaData?.type;

    if (
      type === ZONE_PARAMETER_TYPES.DEMAND ||
      type === ZONE_PARAMETER_TYPES.SUPPLY
    ) {
      return type;
    }

    return null;
  }

  static getEdges(resultMetaData) {
    if (!ZoneParametersHelper.hasZoneParameters(resultMetaData)) {
      return null;
    }

    return {
      bottom: NumberHelper.render(resultMetaData.bottom),
      top: NumberHelper.render(resultMetaData.top)
    };
  }

  static render(resultMetaData) {
    const edges = ZoneParametersHelper.getEdges(resultMetaData);

    if (!edges) {
      return null;
    }

    return `${edges.bottom} - ${edges.top}`;
  }

  static shouldRenderDash(props) {
    return !ZoneParametersHelper.hasZoneParameters(props?.resultMetaData);
  }
}
